export enum CtaType {
    ADD = 'Add',
    SIGNIN = 'Sign in to add',
    CUSTOMIZE = 'Customize',
    TEMPORARILY_UNAVAILABLE = 'Temp. unavailable',
    SELECTWEIGHT = 'Select wt',
    PREORDER = 'Preorder',
    ADDTOORDER="Add to order",
}
